module.exports = __webpack_public_path__ + "img/en_logo.6a9d58be.png";